import React from 'react';
import { MetricCard } from '../ui';
import { getValueStatus, getTrend } from '../../utils';

/**
 * Temperature metrics section
 */
export const TemperatureSection = ({ latestData, previousData, sensorConfig }) => {
  return (
    <>
      <div className="section-title">
        <span className="section-icon">🌡️</span>
        Temperaturas
      </div>
      <div className="dashboard-grid fade-in stagger-1">
        <MetricCard
          icon="🌡️"
          label="Temperatura Ambiente 1"
          value={latestData.temp1}
          unit="°C"
          type="temp"
          trend={getTrend(latestData, previousData, 'temp1')}
          valueStatus={getValueStatus(latestData.temp1, sensorConfig.temperature)}
        />
        <MetricCard
          icon="🌡️"
          label="Temperatura Ambiente 2"
          value={latestData.temp2}
          unit="°C"
          type="temp"
          trend={getTrend(latestData, previousData, 'temp2')}
          valueStatus={getValueStatus(latestData.temp2, sensorConfig.temperature)}
        />
        <MetricCard
          icon="💧"
          label="Temp Sensor DO 1"
          value={latestData.temp_do1}
          unit="°C"
          type="sensor"
          trend={getTrend(latestData, previousData, 'temp_do1')}
          valueStatus={getValueStatus(latestData.temp_do1, sensorConfig.temperature)}
        />
        <MetricCard
          icon="💧"
          label="Temp Sensor DO 2"
          value={latestData.temp_do2}
          unit="°C"
          type="sensor"
          trend={getTrend(latestData, previousData, 'temp_do2')}
          valueStatus={getValueStatus(latestData.temp_do2, sensorConfig.temperature)}
        />
      </div>
    </>
  );
};
